import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useAudioPlayer } from '../pages/Main/components/useAudioPlayer'
import { AUDIO_PVP_URL } from '../constants/audioAssets'

function isPvPRoute(pathname: string): boolean {
  return pathname.startsWith('/pvp')
}

/**
 * Global PvP music player. Keeps music playing across all PvP pages
 * (lobby, select-characters, waiting, vs, battle) so music doesn't restart on navigation.
 */
export const PvPMusicPlayer: React.FC = () => {
  const location = useLocation()
  const backgroundMusicEnabled = useSelector((state: RootState) => state.app.settings.backgroundMusicEnabled)
  const musicVolume = useSelector((state: RootState) => state.app.settings.musicVolume)
  const musicDucked = useSelector((state: RootState) => state.app.settings.musicDucked)

  const isPvP = isPvPRoute(location.pathname)
  const shouldPlay = backgroundMusicEnabled && isPvP && !musicDucked

  const audioRef = useAudioPlayer({
    backgroundMusicEnabled: shouldPlay,
    musicVolume,
  })

  return (
    <audio
      ref={audioRef}
      src={AUDIO_PVP_URL}
      loop
      preload="metadata"
      onError={(e) => {
        console.error('PvP music loading error:', e)
      }}
    />
  )
}
